/**
 * Our own lifecycle for a stripe_payment row, stored in `status`. Stripe's raw PaymentIntent status
 * is kept separately in `payment_intent_status`.
 */
export var StripePaymentStatus;
(function (StripePaymentStatus) {
    StripePaymentStatus["PENDING"] = "pending";
    StripePaymentStatus["PROCESSING"] = "processing";
    /** Waiting on the customer, e.g. 3DS or bank account microdeposit verification */
    StripePaymentStatus["REQUIRES_ACTION"] = "requires_action";
    StripePaymentStatus["PAID"] = "paid";
    StripePaymentStatus["FAILED"] = "failed";
    StripePaymentStatus["EXPIRED"] = "expired";
    StripePaymentStatus["UNKNOWN"] = "unknown";
})(StripePaymentStatus || (StripePaymentStatus = {}));
/** Status shown in the customer payments table: StripePaymentStatus with pending split into started / abandoned */
export var CustomerPaymentStatus;
(function (CustomerPaymentStatus) {
    CustomerPaymentStatus["PAID"] = "paid";
    CustomerPaymentStatus["PROCESSING"] = "processing";
    CustomerPaymentStatus["REQUIRES_ACTION"] = "requires_action";
    CustomerPaymentStatus["EXPIRED"] = "expired";
    CustomerPaymentStatus["FAILED"] = "failed";
    CustomerPaymentStatus["UNKNOWN"] = "unknown";
    /** Pending checkout updated within the last 10 minutes */
    CustomerPaymentStatus["STARTED"] = "started";
    /** Pending checkout not updated for more than 10 minutes. Hidden from the list by default */
    CustomerPaymentStatus["ABANDONED"] = "abandoned";
})(CustomerPaymentStatus || (CustomerPaymentStatus = {}));
//# sourceMappingURL=customerPayment.js.map